<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({}),
  mounted () {
    // Check if the device widht is more than 1024 side drawer should remain open
    if (this.$vuetify.breakpoint.width <= 1024) {
      this.$globalStates.showSideDrawer = false
    }
  }
}
</script>

<style lang="scss">
@import './assets/Style.scss';
@import './sass/_main-style';
</style>
